module.exports = __webpack_public_path__ + "img/icon-merck-0f69af.97acf43c.svg";